// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.functionx",
    name: "f(x)Wallet",
    homepage: "https://functionx.io/home",
    image_id: "bdd2f39b-98fa-485d-b180-bf4a42fa6100",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/f-x-wallet-by-function-x-labs/id1504798360",
        android: "https://play.google.com/store/apps/details?id=com.pundix.functionx",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "fxwallet://",
        universal: "https://fx.wallet/wc",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map